import React, { useState } from 'react'
import PageHeader from '../../../components/pageHeader/PageHeader'
import TableViewType from '../../../components/tableViewType/TableViewType'
import { Spacing } from '../../../components/table/Table'
import SourcesFilters from './SourcesFilters'
import { ILink } from '../../../types'
import { PATHS } from '../../../routes/Routes'
import SourcesTable from './SourcesTable'
import SourceActions from './Actions/SourceActions'

const Sources = () => {
  const [viewType, setViewType] = useState<Spacing>(Spacing.Default)
  const navLinks: ILink[] = [
    {
      label: 'Batch Activity',
      link: PATHS.BATCH_ACTIVITY,
    },
    {
      label: 'Sources',
      link: PATHS.SOURCES,
    },
  ]
  return (
    <div className='page-container'>
      <PageHeader header='Sources' navLinks={navLinks}>
        <SourceActions />
      </PageHeader>
      <div className='page-content'>
        <div className='table-filters'>
          <div className='filters-container'>
            <SourcesFilters />
          </div>
          <div className='table-view-type'>
            <TableViewType viewType={viewType} setViewType={setViewType} />
          </div>
        </div>
        <SourcesTable spacing={viewType} />
      </div>
    </div>
  )
}
export default Sources
